const EmailIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="18"
    viewBox="0 0 26 18"
  >
    <g fill="white" fillRule="evenodd">
      <path d="M13.2 10L24.6.2H1.4L12.8 10h.4z" />
      <path d="M14.2 11.2c-.4.2-.8.4-1.2.4-.4 0-.8-.2-1.2-.4L.2 1.4V17c0 .6.4 1 1 1h23.4c.6 0 1-.4 1-1V1.4l-11.4 9.8z" />
    </g>
  </svg>
);

export default EmailIcon;
